module.exports = __webpack_public_path__ + "e4f8dc63e6e27a44341f97c275c9f684.png";